/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationIPWhitelistRequest
 */
export interface CreateOrganizationIPWhitelistRequest {
    /**
     * The IP address or CIDR notation to whitelist (e.g., 192.168.1.1 or 192.168.1.0/24)
     * @type {string}
     * @memberof CreateOrganizationIPWhitelistRequest
     */
    ip_address: string;
    /**
     * Optional description for the IP address
     * @type {string}
     * @memberof CreateOrganizationIPWhitelistRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the CreateOrganizationIPWhitelistRequest interface.
 */
export function instanceOfCreateOrganizationIPWhitelistRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ip_address" in value;

    return isInstance;
}

export function CreateOrganizationIPWhitelistRequestFromJSON(json: any): CreateOrganizationIPWhitelistRequest {
    return CreateOrganizationIPWhitelistRequestFromJSONTyped(json, false);
}

export function CreateOrganizationIPWhitelistRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationIPWhitelistRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ip_address': json['ip_address'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function CreateOrganizationIPWhitelistRequestToJSON(value?: CreateOrganizationIPWhitelistRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ip_address': value.ip_address,
        'description': value.description,
    };
}

